export default {
  name: 'Łącznik',
  langListTitle: 'Połącz dwa obiekty',
  langList: [
    { id: 'mode_connect', title: 'Połącz dwa obiekty' }
  ],
  buttons: [
    {
      title: 'Połącz dwa obiekty'
    }
  ]
}